import { createSelector } from 'reselect'
import { ACTIVITY_CATEGORIES } from 'constants/enums'

const stateActivities = (activities, parentId, otherLabel) => ({
  activities,
  parentId,
  otherLabel
})

const mapForDropdown = ({ activities, parentId, otherLabel }) => {
  let appendedActivities = activities

  if (otherLabel) {
    appendedActivities = appendedActivities.concat({
      id: ACTIVITY_CATEGORIES.other.id,
      translatedName: otherLabel || 'Other',
      parent: {
        id: parentId
      }
    })
  }


  if (parentId) {
    appendedActivities = appendedActivities.filter(
      item => item.parent && item.parent.id === parentId
    )
  }

  return appendedActivities.map(item => ({
    value: item.id,
    label: item.translatedName
  }))
}

export default createSelector(stateActivities, mapForDropdown)
